import React, { type FC } from "react";
import { RemoveMembersConfirmationModal } from "../../../../../../../../components/people";
import { bindActionCreators } from "redux";
import * as backgroundTasksActionsRedux from "../../../../../../../BackgroundTasks/state/backgroundTasksActions";
import * as notificationsActionsRedux from "../../../../../../../Notifications/state/notificationsActions";
import { removeUsersFromGroupTask } from "../../../../../EditGroup/EditPeople/backgroundTasks/removeUsersFromGroupTask";
import backgroundTask from "../../../../../../../BackgroundTasks/backgroundTask";
import { bindAction } from "../../../../../../../../interfaces";
import { connect, type ConnectedProps } from "react-redux";
import { type AppDispatch, type RootState } from "../../../../../../../Application/globaltypes/redux";
import { resetSelectedItems } from "../../../../state/slices/groupMembersInfoSlice";
import { setActiveModal } from "../../../../state/slices/groupMembersModalsSlice";

export interface Props extends PropsFromRedux {
  groupId: number;
}
export const RemoveMembersConfirmationModalContainer: FC<Props> = (props) => {
  const onCancelHandler = () => {
    props.resetSelectedItemsAction();
    props.setActiveModalAction(null);
  };

  const onRemoveEnrolledGroupMembers = () => {
    removeUsersFromGroupTask(props.selectedIds, props.groupId, (params) =>
      backgroundTask.updateEntityV2(params, {
        addOperation: props.backgroundTasksActions.addOperationV2,
        sendTransientNotification: props.notificationsActions.sendTransientNotification,
      }),
    ).then(onCancelHandler);
  };

  return (
    <RemoveMembersConfirmationModal
      open
      usersCount={props.selectedIds.length}
      onCancel={onCancelHandler}
      onContinue={onRemoveEnrolledGroupMembers}
      featureName="group"
    />
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  selectedIds: state.people.addGroup.groupMembers.overview.list.selectedIds,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  backgroundTasksActions: bindActionCreators(backgroundTasksActionsRedux, dispatch),
  notificationsActions: bindActionCreators(notificationsActionsRedux, dispatch),
  resetSelectedItemsAction: bindAction(resetSelectedItems, dispatch),
  setActiveModalAction: bindAction(setActiveModal, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(RemoveMembersConfirmationModalContainer);
export default ConnectedComponent;
